"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addRole = addRole;
exports.changeState = changeState;
exports.getRole = getRole;
exports.getRoleList = getRoleList;
exports.getRoleSelection = getRoleSelection;
exports.updateRole = updateRole;
exports.updateState = updateState;
var _request = _interopRequireDefault(require("@/utils/request"));
function getRoleList(data) {
  return (0, _request.default)({
    url: '/api/v1/role',
    method: 'get',
    params: data
  });
}
function getRole(id) {
  return (0, _request.default)({
    url: "/api/v1/role/".concat(id),
    method: 'get'
  });
}
function addRole(data) {
  return (0, _request.default)({
    url: '/api/v1/role',
    method: 'post',
    data: data
  });
}
function updateRole(data) {
  return (0, _request.default)({
    url: "/api/v1/role/".concat(data.id),
    method: 'patch',
    data: data
  });
}
function changeState(data) {
  return (0, _request.default)({
    url: "/api/v1/role/".concat(data.id),
    method: 'post',
    data: data
  });
}
function getRoleSelection() {
  return (0, _request.default)({
    url: "/api/v1/role/list/get",
    method: 'get'
  });
}
function updateState(data) {
  return (0, _request.default)({
    url: "/api/v1/role/" + data.id,
    method: 'post',
    data: data
  });
}